import store from "@/store";

export async function postalCodeHandlerFinancial(form, data, country, populateAction) {
    let cpExtField = form.fields.find((field) => (field?.key?.startsWith('cpExt')));
    const districtField = form.fields.find((f) => (f?.key?.startsWith("district")));
    const cp4Field = form.fields.find((f) => f?.key?.startsWith("cp4"));
    const cp4Value = cp4Field?.value?.toString();

    // Para Portugal
    if (country === "PT") {
        const cp3Field = form.fields.find((f) => f?.key?.startsWith("cp3"));
        const cp3Value = cp3Field?.value?.toString();

        if (cp4Value.length === 4 && cp3Field?.maxLength === cp3Value.length) {
            const postalCodeValue = cp4Value + cp3Value;
            const {districtValue} = await store.dispatch(populateAction.name, {
                formNationality: country,
                localityFieldKey: cpExtField?.key,
                postalCode: postalCodeValue
            });
            //Distrito
            districtField.value = districtValue;
            districtField.editable = false;
            //Cidade
            const cityValues = store.getters["FinancialsBkoFormModule/getSearchByPostalCode"](cpExtField.key);

            if (cityValues.length > 1) {
                if (cityValues.length >= 2) {
                    cityValues?.map((option) => {
                        option.selected = option?.value == data?.cpExt;
                    });

                    // Create a promise to handle the asynchronous update
                    const updateAddress1CityValue = new Promise((resolve) => {
                        resolve(cityValues[1]?.text);
                    });

                    // Update cpExtField.value when the promise is resolved
                    updateAddress1CityValue.then((updatedValue) => {
                        cpExtField.value = updatedValue;
                        console.log(cityValues[1]?.text, cpExtField.value);
                    });
                }
                store.commit("FinancialsBkoFormModule/setFieldAttribute", {
                    key: cpExtField?.key,
                    attribute: 'options',
                    value: cityValues
                });
                store.commit("FinancialsBkoFormModule/setFieldValue", cpExtField);
                store.commit("FinancialsBkoFormModule/setIncrementField", {key: cpExtField?.key});
            } else {
                cpExtField.type = "text";
            }

        } else {
            cpExtField.type = "text";
        }
    }
    // Para Espanha
    else {
        if (cp4Value?.length >= 4 && cp4Value?.length <= 5) {
            const {districtValue} = await store.dispatch(populateAction.name, {
                formNationality: country,
                localityFieldKey: cpExtField?.key,
                postalCode: cp4Value
            });
            //Distrito
            districtField.value = districtValue;
            districtField.editable = false;
            //Cidade
            const cityValues = store.getters["FinancialsBkoFormModule/getSearchByPostalCode"](cpExtField.key);
            if (cityValues.length > 1) {
                if (cityValues.length === 2) {
                    cityValues[1].selected = true;

                    // Create a promise to handle the asynchronous update
                    const updateAddress1CityValue = new Promise((resolve) => {
                        resolve(cityValues[1]?.text);
                    });

                    // Update cpExtField.value when the promise is resolved
                    updateAddress1CityValue.then((updatedValue) => {
                        cpExtField.value = updatedValue;
                        console.log(cityValues[1]?.text, cpExtField.value);
                    });
                }
                store.commit("FinancialsBkoFormModule/setFieldAttribute", {
                    key: cpExtField?.key,
                    attribute: 'options',
                    value: cityValues
                });
                store.commit("FinancialsBkoFormModule/setFieldValue", cpExtField);
                store.commit("FinancialsBkoFormModule/setIncrementField", {key: cpExtField?.key});
            } else {
                cpExtField.type = "text";
            }
        } else {
            cpExtField.type = "text";
        }
    }
}